import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { comparerByDate } from '@app/comparers';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  FollowCountryActionsUnion,
  FollowCountryActionTypes
} from '@core/actions/follow-country.actions';
import { Follow } from '@app/models/follow';

export interface State extends EntityState<any> {
  //   loading: boolean;
  //   loaded: boolean;
  //   selectedId: number;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>({
  selectId: (country: any) => country.index
});

export const INITIAL_STATE: State = adapter.getInitialState({
  //   loading: false,
  //   loaded: false,
  //   selectedId: null
});

export function reducer(
  state: State = INITIAL_STATE,
  action: FollowCountryActionsUnion
) {
  switch (action.type) {
    case FollowCountryActionTypes.AddMany:
      return adapter.addMany(action.countries, state);

    default:
      return state;
  }
}

const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const getFollowCountriesState = createFeatureSelector<State>(
  'followCountries'
);

export const getFollowCountries = createSelector(
  getFollowCountriesState,
  selectAll
);
